/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match */

import { ListGroupBy } from '../common/list-group-by';
import { ListItem } from '../common/list-item';
import { ListSortBy } from '../common/list-sort-by';

export class Schedule implements ListItem {
    public static readonly entityType: string = 'schedule';
    public id: string;
    public name?: string;
    public displayName?: string;
    public phone?: string;
    public email?: string;
    public avatar_url?: string;
    public start_day_of_week?: number;
    public allow_shift_swaps?: boolean;
    public allow_shift_drops?: boolean;
    public auto_swap_approval?: boolean;
    public auto_shift_swaps?: boolean;
    public allow_offsites?: boolean;
    public shift_change_cutoff?: number;
    public sections?: any[];
    public updated_at?: any;
    public location_id?: string;
    public as_manager?: boolean;
    public as_worker?: boolean;

    public selected: boolean;
    public loading: boolean = false;

    /**
     * Validates if this item matches the filter.
     * @param filterBy
     * @param filterValue
     * @returns {boolean}
     */
    isMatchingFilter(filterBy: string, filterValue: any): boolean {
        let isMatching: boolean = true;

        switch (filterBy) {
            default:
                isMatching = true;
                break;
        }

        return isMatching;
    }

    /**
     * Validates if this item matches the selected groups.
     * @param groupBy
     * @param selectedGroups
     * @returns {boolean}
     */
    isMatchingGroup(
        groupBy: ListGroupBy,
        selectedGroups: string[]
    ): boolean {
        return true;
    }

    /**
     * Custom valueOf allows for param based sort / comparision
     * @param ref
     * @returns {any}
     */
    valueOf(ref?: any): any {
        let res: any = this;
        if (ref === ListSortBy.NAME && this.name) {
            // location name sorting
            res = this.name.toLowerCase();
        }

        return res;
    }

    /**
     * Returns the relevant group data for this item.
     * @param groupBy
     * @returns {string}
     */
    getGroup(groupBy?: ListGroupBy): string {
        let group: string = '';

        return group;
    }
}
